import http from "./http-common";

class OtService {
  queryString(payload = {}) {
    return Object.entries(payload || {})
      .filter(
        ([_, value]) => value !== undefined && value !== null && value !== ""
      )
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join("&");
  }

  getOtBookingList(payload = { pageNo: 1 }) {
    const query = this.queryString(payload);
    return http.get(
      query ? `/OtBooking/list/filter?${query}` : `/OtBooking/list/filter`
    );
  }

  getOtBookingCount(payload = {}) {
    const query = this.queryString(payload);
    return http.get(
      query ? `/OtBooking/count?${query}` : `/OtBooking/count`
    );
  }

  getOtBookingById(id) {
    return http.get(`/OtBooking/${id}`);
  }
}

const otService = new OtService();
export { otService as OtBookingService };
export default otService;
